import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import MainLayout from "../../Layout/mainLayout";
import { addNews } from "../../Redux/Actions/newsAction";
import { useDispatch, useSelector } from "react-redux";
import {
  viewCityList,
  viewCountryListPagination,
  viewStateListPagination,
} from "../../Redux/Actions/settingsActions";
import { sendNotification } from "../../Redux/Actions/notificationActions";
import toast from "react-hot-toast";
import AddImage from "../../Global Functions/addImage";
import { getProjectList } from "../../Redux/Actions/projectActions";
import { getEnums } from "../../Redux/Actions/enumsActions";
import { viewCategoryList } from "../../Redux/Actions/categoryActions";
import ImageShowerModal from "../../Global Functions/imageShowerModal";
import "./addNews.css";

const TITLE_LIMIT = 50;

const AddNews = () => {
  const [newsData, setNewsData] = useState({
    title: "",
    description: "",
    url: "",
    type: "",
    news_link: "",
    start_date: "",
    end_date: "",
    country: "",
    city: "",
    state: "",
    project: "",
    category: "",
  });

  const [selection, setSelection] = useState("");
  const [uploading, setUploading] = useState({ image: false, video: false });
  const [activeSection, setActiveSection] = useState(0);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const uploadOptions = ["file", "url"];
  const categoryOptions = ["trending", "what's new", "luxury"];
  const sections = ["Basic Info", "Location & Dates", "Media & Links"];

  const { countryList } = useSelector((state) => state.country || {});
  const { states } = useSelector((state) => state.states || {});
  const { cities } = useSelector((state) => state.city || {});
  const { enumsData } = useSelector((state) => state.enumsData || {});
  const { projects } = useSelector((state) => state.projects || {});

  const handleAddChange = (event) => {
    const { name, value } = event.target;
    if (name === "title" && value.length > TITLE_LIMIT) return;
    setNewsData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const filteredNewsData = newsData
        ? Object.fromEntries(
          Object.entries(newsData).filter(([key, value]) => Boolean(value))
        )
        : {};

      if (!filteredNewsData.category) return toast.error("Category is required");

      const response = await dispatch(addNews(filteredNewsData));
      if (response.statusCode === 200) {
        try {
          await dispatch(
            sendNotification({
              title: newsData.title,
              message: newsData.description?.substring(0, 100) + "...",
              type_name: "news",
              type_id: response.data?._id || filteredNewsData.project || "new",
              type: "all",
              notification_for: "user",
              list: [],
              // image: newsData.type === "image" ? newsData.url : "",
              image: newsData.url,
              type_data: {
                category: newsData.category,
                title: newsData.title,
                description: newsData.description?.substring(0, 100) + "...",
                url: newsData.url,
              },
            })
          );
          // toast.success("News added and notification sent successfully!");
        } catch (notificationError) {
          console.error("Notification failed:", notificationError);
        }
        navigate("/news_and_articles");
      }
    } catch (error) { }
  };

  const handleFileUpload = async (event) => {
    const uploadedFile = event.target.files[0];
    const inputId = event.target.id;
    if (!uploadedFile) return;
    setUploading((prev) => ({ ...prev, [inputId]: true }));
    const responseUrl = await AddImage(uploadedFile);
    setUploading((prev) => ({ ...prev, [inputId]: false }));
    if (responseUrl) {
      setNewsData((prevData) => ({
        ...prevData,
        url: responseUrl,
        type: inputId === "image" ? "image" : "video",
      }));
    }
  };

  useEffect(() => {
    dispatch(viewCountryListPagination());
    if (newsData.country) {
      dispatch(viewStateListPagination({ country: newsData.country }));
    }
    if (newsData.state) {
      dispatch(
        viewCityList({
          state: newsData.state,
          country: newsData.country,
          page: 1,
          limit: 200,
        })
      );
    }
  }, [newsData.country, newsData.state, dispatch]);

  useEffect(() => {
    dispatch(getEnums());
    dispatch(viewCategoryList({ page: 1, limit: 100 }));
    const projectStatus = enumsData?.data?.ProjectStatus
      ? Object.values(enumsData.data.ProjectStatus)
      : ["requested", "approved", "declined", "published", "unpublished", "sold"];
    dispatch(
      getProjectList({ status: projectStatus, page: 1, limit: 500, is_deleted: false })
    );
  }, [dispatch]);

  return (
    <MainLayout>
      <div className="an-wrapper">
        <div className="an-header">
          <div className="an-header-left">
            <div className="an-header-icon">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <polyline points="14 2 14 8 20 8" />
                <line x1="16" y1="13" x2="8" y2="13" />
                <line x1="16" y1="17" x2="8" y2="17" />
                <polyline points="10 9 9 9 8 9" />
              </svg>
            </div>
            <div>
              <h1 className="an-title">Add News / Article</h1>
              <p className="an-subtitle">Fill in the details to publish a new article</p>
            </div>
          </div>
          <Link to="/news_and_articles" className="an-view-btn">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
              <polyline points="14 2 14 8 20 8" />
            </svg>
            View News List
          </Link>
        </div>

        <div className="an-nav">
          {sections.map((sec, i) => (
            <button
              key={i}
              className={`an-nav-pill ${activeSection === i ? "an-nav-pill--active" : ""}`}
              onClick={() => setActiveSection(i)}
              type="button"
            >
              <span className="an-nav-num">{String(i + 1).padStart(2, "0")}</span>
              {sec}
            </button>
          ))}
        </div>

        <form className="an-form">
          <div className={`an-section ${activeSection === 0 ? "an-section--visible" : ""}`}>
            <div className="an-section-header">
              <span className="an-section-badge">01</span>
              <h2 className="an-section-title">Basic Information</h2>
            </div>
            <div className="an-grid an-grid-2">
              <div className="an-field">
                <label className="an-label">
                  Title <span className="an-req">*</span>
                </label>
                <input
                  className="an-input"
                  type="text"
                  name="title"
                  value={newsData.title}
                  onChange={handleAddChange}
                  placeholder="Enter news title"
                  maxLength={TITLE_LIMIT}
                />
                <span className="an-char-count">
                  {newsData.title.length}/{TITLE_LIMIT}
                </span>
              </div>
              <div className="an-field">
                <label className="an-label">
                  Category <span className="an-req">*</span>
                </label>
                <select
                  className="an-select"
                  name="category"
                  value={newsData.category}
                  onChange={handleAddChange}
                >
                  <option value="">Select a category</option>
                  {categoryOptions.map((cat) => (
                    <option key={cat} value={cat}>
                      {cat.charAt(0).toUpperCase() + cat.slice(1)}
                    </option>
                  ))}
                </select>
              </div>
              <div className="an-field an-field--full">
                <label className="an-label">
                  Description <span className="an-req">*</span>
                </label>
                <textarea
                  className="an-textarea"
                  name="description"
                  value={newsData.description}
                  onChange={handleAddChange}
                  placeholder="Write a detailed description..."
                  rows={4}
                />
              </div>
              <div className="an-field">
                <label className="an-label">
                  Select Project <span className="an-optional">(Optional)</span>
                </label>
                <select
                  className="an-select"
                  name="project"
                  value={newsData.project}
                  onChange={handleAddChange}
                >
                  <option value="">Select a project</option>
                  {Array.isArray(projects?.data) &&
                    projects.data.map((project) => (
                      <option key={project._id} value={project._id}>
                        {project.project_name}
                      </option>
                    ))}
                </select>
              </div>
              <div className="an-field">
                <label className="an-label">
                  News Link <span className="an-optional">(Optional)</span>
                </label>
                <input
                  className="an-input"
                  type="text"
                  name="news_link"
                  value={newsData.news_link}
                  onChange={handleAddChange}
                  placeholder="https://example.com/article"
                />
              </div>
            </div>
          </div>

          <div className={`an-section ${activeSection === 1 ? "an-section--visible" : ""}`}>
            <div className="an-section-header">
              <span className="an-section-badge">02</span>
              <h2 className="an-section-title">Location & Dates</h2>
            </div>
            <div className="an-grid an-grid-2">
              <div className="an-field">
                <label className="an-label">
                  Country <span className="an-optional">(Optional)</span>
                </label>
                <select
                  className="an-select"
                  name="country"
                  value={newsData.country}
                  onChange={handleAddChange}
                >
                  <option value="">Select country</option>
                  {Array.isArray(countryList?.data) &&
                    countryList.data.map((country) => (
                      <option key={country._id} value={country._id}>
                        {country.country_name}
                      </option>
                    ))}
                </select>
              </div>
              <div className="an-field">
                <label className="an-label">
                  State <span className="an-optional">(Optional)</span>
                </label>
                <select
                  className={`an-select ${!newsData.country ? "an-select--disabled" : ""}`}
                  name="state"
                  value={newsData.state}
                  onChange={handleAddChange}
                  disabled={!newsData.country}
                >
                  <option value="">
                    {!newsData.country ? "Select country first" : "Select state"}
                  </option>
                  {Array.isArray(states?.data) &&
                    states.data.map((state) => (
                      <option key={state._id} value={state._id}>
                        {state.state_name}
                      </option>
                    ))}
                </select>
              </div>
              <div className="an-field">
                <label className="an-label">
                  City <span className="an-optional">(Optional)</span>
                </label>
                <select
                  className={`an-select ${!newsData.state ? "an-select--disabled" : ""}`}
                  name="city"
                  value={newsData.city}
                  onChange={handleAddChange}
                  disabled={!newsData.state}
                >
                  <option value="">
                    {!newsData.state ? "Select state first" : "Select city"}
                  </option>
                  {Array.isArray(cities?.data) &&
                    cities.data.map((city) => (
                      <option key={city._id} value={city._id}>
                        {city.city_name}
                      </option>
                    ))}
                </select>
              </div>
              <div className="an-field" />
              <div className="an-field">
                <label className="an-label">
                  Start Date <span className="an-optional">(Optional)</span>
                </label>
                <input
                  className="an-input"
                  type="date"
                  name="start_date"
                  value={newsData.start_date}
                  onChange={handleAddChange}
                />
              </div>
              <div className="an-field">
                <label className="an-label">
                  End Date <span className="an-optional">(Optional)</span>
                </label>
                <input
                  className="an-input"
                  type="date"
                  name="end_date"
                  value={newsData.end_date}
                  onChange={handleAddChange}
                />
              </div>
            </div>
          </div>

          <div className={`an-section ${activeSection === 2 ? "an-section--visible" : ""}`}>
            <div className="an-section-header">
              <span className="an-section-badge">03</span>
              <h2 className="an-section-title">Media & Links</h2>
            </div>
            <div className="an-grid an-grid-2">
              <div className="an-field">
                <label className="an-label">
                  Upload Type <span className="an-optional">(Optional)</span>
                </label>
                <select
                  className="an-select"
                  value={selection}
                  onChange={(event) => setSelection(event.target.value)}
                >
                  <option value="">Select upload type</option>
                  {uploadOptions.map((opt) => (
                    <option key={opt} value={opt}>
                      {opt.toUpperCase()}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {selection === "file" && (
              <div className="an-grid an-grid-2" style={{ marginTop: "20px" }}>
                <div className="an-field">
                  <label className="an-label">Upload Image</label>
                  <input
                    className="an-input"
                    type="file"
                    id="image"
                    disabled={!!newsData.url || uploading.image}
                    onChange={handleFileUpload}
                    accept="image/*"
                  />
                  {uploading.image && (
                    <span className="an-upload-loader">
                      <span className="an-spinner" /> Uploading image...
                    </span>
                  )}
                  {newsData.url && newsData.type === "image" && (
                    <ImageShowerModal
                      file={newsData.url}
                      onClick={() => setNewsData((prev) => ({ ...prev, url: "", type: "" }))}
                    />
                  )}
                </div>

                <div className="an-field">
                  <label className="an-label">Upload Video</label>
                  <input
                    className="an-input"
                    type="file"
                    id="video"
                    disabled={!!newsData.url || uploading.video}
                    onChange={handleFileUpload}
                    accept="video/*"
                  />
                  {uploading.video && (
                    <span className="an-upload-loader">
                      <span className="an-spinner" /> Uploading video...
                    </span>
                  )}
                  {newsData.url && newsData.type === "video" && (
                    <ImageShowerModal
                      file={newsData.url}
                      onClick={() => setNewsData((prev) => ({ ...prev, url: "", type: "" }))}
                    />
                  )}
                </div>
              </div>
            )}

            {selection === "url" && (
              <div className="an-grid an-grid-2" style={{ marginTop: "20px" }}>
                <div className="an-field an-field--full">
                  <label className="an-label">Media URL</label>
                  <input
                    className="an-input"
                    type="text"
                    name="url"
                    value={newsData.url}
                    onChange={handleAddChange}
                    placeholder="https://example.com/image.jpg"
                  />
                </div>
              </div>
            )}
          </div>

          <div className="an-footer">
            <div className="an-footer-nav">
              <button
                type="button"
                className="an-btn an-btn--ghost"
                onClick={() => setActiveSection((s) => Math.max(0, s - 1))}
                disabled={activeSection === 0}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="15 18 9 12 15 6" />
                </svg>
                Back
              </button>
              {activeSection < sections.length - 1 ? (
                <button
                  type="button"
                  className="an-btn an-btn--primary"
                  onClick={() =>
                    setActiveSection((s) => Math.min(sections.length - 1, s + 1))
                  }
                >
                  Next
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="9 18 15 12 9 6" />
                  </svg>
                </button>
              ) : (
                <button type="button" onClick={handleSubmit} className="an-btn an-btn--submit">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                  Save Article
                </button>
              )}
            </div>
            <Link to="/news_and_articles" className="an-btn an-btn--cancel">
              Cancel
            </Link>
          </div>
        </form>
      </div>
    </MainLayout>
  );
};

export default AddNews;